/* eslint react/no-danger: 0 */
import React from 'react'
import {
  Card,
  Fieldset,
  ContentSection,
  Heading,
} from '@vwfs-bronson/bronson-react'
import { useSelector } from 'react-redux'
import { FastField } from 'formik'
import { CheckboxField } from '../../../components/CheckboxField'
import ExplanationComponent from './components/ExplanationComponent'
import PrivacyComponent from './components/PrivacyComponent'
import { isAUDI, isVtiGiS } from '../../../services/common/utils'
import LimitationPeriod from '../LimitationPeriod'
import { getStorefrontData } from '../../../services/redux/features/storefront.redux'
import { WarrantyLegalComponent } from './components/WarrantyLegalComponent'

const DataProtectionFieldset = ({ t, inspectionReportLink }) => {
  const storefrontData = useSelector(getStorefrontData)

  const dataProtectionUrl = () => {
    return isVtiGiS(storefrontData)
      ? '/documents/Datenschutzinformation_VTI_GmbH.pdf'
      : storefrontData?.dealerData?.dataProtectionUrl
  }

  return (
    <>
      <ContentSection.ComponentWrapper className="u-mb-none">
        <Fieldset>
          {isVtiGiS(storefrontData) && (
            <ContentSection className="u-pt-small u-pb-small">
              <Card
                title={
                  <Heading level={2}>
                    {t('form:dataProtection:vtiGis:deviationAgreeTitle')}
                  </Heading>
                }
                className="u-text-left u-pt-small u-pb-small"
              >
                <Fieldset.Row>
                  <FastField
                    name="acceptVehicleDifferences"
                    label={
                      <>
                        <p>
                          {t(
                            'form:dataProtection:vtiGis:deviationAgreeCheckbox1'
                          )}
                        </p>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: t(
                              'form:dataProtection:vtiGis:deviationAgreeCheckbox1Text2',
                              { link: inspectionReportLink }
                            ),
                          }}
                        ></p>
                      </>
                    }
                    required
                    component={CheckboxField}
                  />
                </Fieldset.Row>
                <ContentSection className="u-pt-small u-pb-small">
                  <LimitationPeriod />
                </ContentSection>
              </Card>
            </ContentSection>
          )}
          {!isAUDI(storefrontData) && (
            <ContentSection className="u-pt-small u-pb-small">
              <ExplanationComponent />
            </ContentSection>
          )}
          {isVtiGiS(storefrontData) && (
            <ContentSection className="u-pt-small u-pb-small">
              <WarrantyLegalComponent />
            </ContentSection>
          )}
          <ContentSection className="u-pt-small u-pb-small">
            <PrivacyComponent dataProtectionUrl={dataProtectionUrl} />
          </ContentSection>
        </Fieldset>
      </ContentSection.ComponentWrapper>
    </>
  )
}

export default DataProtectionFieldset
